import { render, staticRenderFns } from "./buyerCenter.vue?vue&type=template&id=69f9cf8b&scoped=true"
import script from "./buyerCenter.vue?vue&type=script&lang=js"
export * from "./buyerCenter.vue?vue&type=script&lang=js"
import style0 from "./buyerCenter.vue?vue&type=style&index=0&id=69f9cf8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f9cf8b",
  null
  
)

export default component.exports